import LanguageField from '../common/fields/common_fields/LanguageField';
import { SelectCurrency } from '../common/SelectCurrency';

export const CurrencyLangSelect = () => {
    return (
        <div className="navbar-select">
            <SelectCurrency />
            <span className="navbar-select__divider">|</span>
            <LanguageField />
        </div>
    );
};
